import React from 'react';
import ParticipationTokenValue from './ParticipationTokenValue';

export default function HeroTokenSegment({
  label,
  iconSrc,
  hideIcon = false,
  loading,
  player,
  redacted,
  value,
}) {
  const segmentClass = [
    'member-dashboard__org-segment',
    'member-dashboard__org-segment--token',
    hideIcon ? 'member-dashboard__org-segment--token-no-icon' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={segmentClass}>
      {!hideIcon && iconSrc ? (
        <div className="member-dashboard__org-icon-wrap">
          <img className="member-dashboard__org-icon" src={iconSrc} alt="" />
        </div>
      ) : null}

      <div className="member-dashboard__org-text">
        <span className="member-dashboard__org-label">{label}</span>
        <span className="member-dashboard__org-value member-dashboard__org-value--token">
          <ParticipationTokenValue
            loading={loading}
            player={player}
            redacted={redacted}
            value={value}
          />
        </span>
      </div>
    </div>
  );
}
